import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '../../shared/services/state.service';

declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.css']
})
export class ActivationComponent implements OnInit {
 

  constructor(private route: ActivatedRoute,
    private router: Router,
    private stateService: StateService) { }


  ngOnInit() {
  
      }



}
